import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

export function ProjectCostsTrends() {
  const data = [
    { name: 'T4/2024', budget: 5, actual: 4, paid: 3 },
    { name: 'T5/2024', budget: 12, actual: 10, paid: 7 },
    { name: 'T6/2024', budget: 18, actual: 15, paid: 11 },
    { name: 'T7/2024', budget: 22, actual: 20, paid: 15 },
    { name: 'T8/2024', budget: 25, actual: 24, paid: 19 },
    { name: 'T9/2024', budget: 28.65, actual: 27, paid: 22 },
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <h3 className="text-sm font-normal text-slate-900 border-b border-slate-50 pb-2">Tình hình chi phí theo thời gian</h3>
      <div className="h-[200px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
            <XAxis 
              dataKey="name" 
              axisLine={false} 
              tickLine={false} 
              tick={{ fontSize: 9, fontStyle: 'normal', fill: '#94a3b8' }} 
            />
            <YAxis 
              axisLine={false} 
              tickLine={false} 
              tick={{ fontSize: 9, fontStyle: 'normal', fill: '#94a3b8' }}
              label={{ value: 'Tỷ (VND)', angle: -90, position: 'insideLeft', style: { fontSize: 9, fontStyle: 'normal', fill: '#94a3b8' } }}
            />
            <Tooltip 
              contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', fontSize: '12px' }}
            />
            <Legend iconType="circle" wrapperStyle={{ fontSize: '12px', fontWeight: 500, paddingTop: '10px' }} />
            <Line type="monotone" dataKey="budget" name="Ngân sách" stroke="#94a3b8" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="actual" name="Đã phát sinh" stroke="#10b981" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="paid" name="Đã thanh toán" stroke="#3b82f6" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
